module.exports = __webpack_public_path__ + "img/problem_soap_dispenser.73202c31.svg";